"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Position = Position;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Styled components
// -------------------------------------------------------------------------------------------------

// Make sure that we use styled-component's own typing for the `as` prop.
const Base = _styledComponents.default.div`
  position: fixed;

  ${p => {
  if (!p.at) return null;
  switch (p.at) {
    case 'bottomMiddle':
      return (0, _styledComponents.css)`
          bottom: ${(0, _polished.rem)(p.bottom || p.theme.spacing[2])};
          left: 50%;
          transform: translateX(-50%);
        `;
    case 'middle':
      return (0, _styledComponents.css)`
          left: 50%;
          transform: translate(-50%, -50%);
          top: 50%;
        `;
    default:
      return null;
  }
}}

  ${p => !p.at && (0, _styledComponents.css)`
      ${p.bottom && (0, _styledComponents.css)`
        bottom: ${(0, _polished.rem)(p.bottom)};
      `};
      ${p.left && (0, _styledComponents.css)`
        left: ${(0, _polished.rem)(p.left)};
      `};
      ${p.right && (0, _styledComponents.css)`
        right: ${(0, _polished.rem)(p.right)};
      `};
      ${p.top && (0, _styledComponents.css)`
        top: ${(0, _polished.rem)(p.top)};
      `};
    `}

    ${p => p.zIndex && (0, _styledComponents.css)`
      z-index: ${p.zIndex};
    `}
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
function Position({
  as,
  children,
  testId,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(Base, _extends({
    as: as,
    "data-testid": testId
  }, rest), children);
}